import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "m-filter-modal" }
const _hoisted_2 = { class: "m-filter-header" }
const _hoisted_3 = { class: "m-filter-body scrollbar" }
const _hoisted_4 = {
  key: 0,
  class: "m-filter-planame"
}
const _hoisted_5 = { class: "m-filter-planame relative planName" }
const _hoisted_6 = { class: "m-planame-btn-icon" }
const _hoisted_7 = { class: "form-check" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = {
  key: 1,
  class: "m-filter-planame"
}
const _hoisted_12 = { class: "m-filter-planame-list homeType" }
const _hoisted_13 = ["value", "id"]
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "m-filter-planame" }
const _hoisted_16 = { class: "m-filter-planame-list move-in-days" }
const _hoisted_17 = ["value", "id"]
const _hoisted_18 = { class: "m-filter-footer" }
const _hoisted_19 = { class: "cta__btn" }

import { ref, onMounted, toRefs, watch, computed } from 'vue';
import LongArrowLeftIcon from '@/assets/icons/LongArrowLeftIcon.vue';
import ArrowDownIcon from '@/assets/icons/ArrowDown.vue';
import RangeSlider from './RangeSlider.vue';
import { QmiDaysFilter } from '@/constant';
import { CommunityQmiDetails, QmiDays, SidebarHomePlan, planDetails } from '@/types/sidebar';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileFilterModal',
  props: {
    planPriceExsist: { type: Boolean },
    listHomeTypeMobileFilter: {},
    listPlanNameMobileFilter: {},
    qmiFilterListMobileFilter: {},
    communityHomePlans: {},
    homeTypeList: {},
    selectedNeighborhoodIds: {},
    minPriceRangeMobileFilter: {},
    maxPriceRangeMobileFilter: {},
    showMinPriceRangeMobileFilter: {},
    showMaxPriceRangeMobileFilter: {},
    showPriceRangeMobileFilter: { type: Boolean },
    qmiDetails: {},
    enableMobileApply: { type: Boolean },
    homeTypeCount: {}
  },
  emits: ["toggleMobileFilterModalVisibility", "applyMobileFilters", "clearMobileFilters", "updatePriceRangeMobile", "checkHomeTypeCount"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { planPriceExsist, listHomeTypeMobileFilter, listPlanNameMobileFilter, qmiFilterListMobileFilter, communityHomePlans, homeTypeList, minPriceRangeMobileFilter, maxPriceRangeMobileFilter, showMinPriceRangeMobileFilter, showMaxPriceRangeMobileFilter, showPriceRangeMobileFilter, qmiDetails, enableMobileApply, homeTypeCount } = toRefs(props);

const emit = __emit;

const listHomeType = ref<string[]>([]);
const listPlanName = ref<string[]>([]);
const qmiFilterList = ref<QmiDays[]>([]);
const allPlansSelected = ref(false);
const showPlanName = ref(false);
const disableApply = ref(true);
const isPriceApplied = ref(false);
const planNameQmiList = ref<planDetails[]>([]);
const qmiDaysFilter = QmiDaysFilter;

const changeFilters = computed(() => !!listHomeType.value.length || !!listPlanName.value.length || !!qmiFilterList.value.length);

watch(listPlanName, () => {
  allPlansSelected.value = listPlanName.value.length === planNameQmiList.value.length;
});

watch([changeFilters, isPriceApplied], () => {
  disableApply.value = !(changeFilters.value || isPriceApplied.value);
});

watch(enableMobileApply, (val) => {
  disableApply.value = !val;
  isPriceApplied.value = val;
});

onMounted(() => {
  listHomeType.value = [...listHomeTypeMobileFilter.value];
  listPlanName.value = [...listPlanNameMobileFilter.value];
  qmiFilterList.value = [...qmiFilterListMobileFilter.value];

  if (listPlanName.value.length === communityHomePlans.value.length) {
    allPlansSelected.value = true;
  }

  const planId: string[] = [];
  communityHomePlans.value.forEach((homePlan) => {
    planNameQmiList.value.push({
      plan_id: homePlan.plan_id,
      plan_name: homePlan.plan_name,
    });
    planId.push(homePlan.plan_id);
  });

  for (const key of Object.keys(qmiDetails.value)) {
    qmiDetails.value[key].forEach((qmi) => {
      if (!planId.includes(qmi.plan_code)) {
        planNameQmiList.value.push({
          plan_id: qmi.plan_code,
          plan_name: qmi.plan_market_name,
        });
      }
    });
  }

  window.addEventListener('click', hideDropDown);
});

const hideDropDown = (e: Event) => {
  const planNameEl = document.querySelector('.planName');
  if (planNameEl && !planNameEl.contains(e.target as Node)) {
    showPlanName.value = false;
  }
};

const selectAllPlans = () => {
  listPlanName.value = [];
  if (!allPlansSelected.value) {
    planNameQmiList.value.forEach((plan) => {
      listPlanName.value.push(plan.plan_name);
    });
  }
  allPlansSelected.value = !allPlansSelected.value;
};

const applyFilters = () => {
  emit('applyMobileFilters', {
    listPlanName: listPlanName.value,
    listHomeType: listHomeType.value,
    qmiFilterList: qmiFilterList.value,
  });
  emit('toggleMobileFilterModalVisibility', false);
};

const clearFilters = () => {
  emit('toggleMobileFilterModalVisibility', false);
  emit('clearMobileFilters');
};

const toggleMobileFilterVisibility = (value) => {
  emit('toggleMobileFilterModalVisibility', value);
};

const handleQmiDaysClick = (event: MouseEvent) => {
  const target = event.currentTarget as HTMLElement;
  const qmiDaysValue = target.getAttribute('value');
  if (!qmiDaysValue) return;

  const qmiDay = qmiDaysFilter.find((element) => element.value === qmiDaysValue);
  if (!qmiDay) return;

  const index = qmiFilterList.value.findIndex((opt) => opt.value == qmiDay.value);
  if (index >= 0) {
    qmiFilterList.value = qmiFilterList.value.filter((opt) => opt.value !== qmiDay.value);
  } else {
    qmiFilterList.value = [...qmiFilterList.value, qmiDay];
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "arrow",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleMobileFilterVisibility(false)))
      }, [
        _createVNode(LongArrowLeftIcon, { class: "m-filter-header-icon" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_unref(showPriceRangeMobileFilter) && !_unref(planPriceExsist))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "m-filter-planame-title" }, "Price Range", -1)),
            _createVNode(RangeSlider, {
              min: _unref(minPriceRangeMobileFilter),
              max: _unref(maxPriceRangeMobileFilter),
              showMinRangeOnSlider: _unref(showMinPriceRangeMobileFilter),
              showMaxRangeOnSlider: _unref(showMaxPriceRangeMobileFilter),
              onUpdatePriceRangeMobile: _cache[1] || (_cache[1] = (payload) => emit('updatePriceRangeMobile', payload))
            }, null, 8, ["min", "max", "showMinRangeOnSlider", "showMaxRangeOnSlider"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "fw-ic-jb m-planame-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (showPlanName.value = !showPlanName.value))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "m-filter-planame-title" }, "Plan Name", -1)),
          _createElementVNode("i", _hoisted_6, [
            _createVNode(ArrowDownIcon, {
              class: _normalizeClass({ 'rotate-180': showPlanName.value })
            }, null, 8, ["class"])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(['dropdown m-filter-planame-list', { show: showPlanName.value }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "all",
              class: "form-check-input",
              value: allPlansSelected.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((allPlansSelected).value = $event)),
              onClick: selectAllPlans
            }, null, 8, _hoisted_8), [
              [_vModelCheckbox, allPlansSelected.value]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("label", {
              for: "all",
              class: "form-check-label"
            }, "Select All", -1))
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(planNameQmiList.value, (planName) => {
            return (_openBlock(), _createElementBlock("div", {
              key: planName.plan_id,
              class: "form-check"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                id: planName.plan_id,
                class: "form-check-input",
                value: planName.plan_name,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listPlanName).value = $event))
              }, null, 8, _hoisted_9), [
                [_vModelCheckbox, listPlanName.value]
              ]),
              _createElementVNode("label", {
                for: planName.plan_id,
                class: "form-check-label"
              }, _toDisplayString(planName.plan_name), 9, _hoisted_10)
            ]))
          }), 128))
        ], 2)
      ]),
      (_unref(homeTypeCount) > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "m-filter-planame-title" }, "Home Type", -1)),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(homeTypeList), (homeType, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "form-check"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: homeType,
                    id: index,
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((listHomeType).value = $event))
                  }, null, 8, _hoisted_13), [
                    [_vModelCheckbox, listHomeType.value]
                  ]),
                  _createElementVNode("label", {
                    for: index,
                    class: "form-check-label"
                  }, _toDisplayString(homeType), 9, _hoisted_14)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_15, [
        _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "m-filter-planame-title" }, "Quick Move-in", -1)),
        _createElementVNode("div", _hoisted_16, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qmiDaysFilter), (option, index) => {
            return (_openBlock(), _createElementBlock("span", {
              key: index,
              class: _normalizeClass(['daysFilter', { active: qmiFilterList.value.some((opt) => opt.value == option.value) }]),
              value: option.value,
              id: option.value,
              onClick: handleQmiDaysClick
            }, _toDisplayString(option.value), 11, _hoisted_17))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "cta__btntext",
          onClick: clearFilters
        }, " Clear "),
        _createElementVNode("button", {
          class: _normalizeClass(["cta__btnsolid", [{ disableApply: disableApply.value }]]),
          onClick: applyFilters
        }, " Apply ", 2)
      ])
    ])
  ]))
}
}

})